module.exports = "<div class=\"portfolio-page-container\">\n  <div class=\"portfolio-element-container\">\n    <portfolio-display *ngFor=\"let work of myWork\" [element]=\"work\"></portfolio-display>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/components/portfolio/portfolio.component.html
// module id = ../../../../../src/app/components/portfolio/portfolio.component.html
// module chunks = 1